import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";

var _class;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "49356xApOlF/pkpnyCcv/ux", "RepeatMove", undefined);

// // Learn TypeScript:
// //  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// // Learn Attribute:
// //  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// // Learn life-cycle callbacks:
// //  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu; // export enum E_RMove_Direction {
//     HORIZONTAL,
//     VERTICAL
// }

var // @menu("act/RepeatMove")
RepeatMove = ccclass(_class = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RepeatMove, _Component);

  function RepeatMove() {
    return _Component.apply(this, arguments) || this;
  }

  return RepeatMove;
}(Component)) || _class;

export { RepeatMove as default };

_cclegacy._RF.pop();